"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testableExternalConfig = void 0;
const tslib_1 = require("tslib");
const base_1 = require("./base");
const default_1 = require("./default");
/** Sub Project imports REGEX MARKER GROUP - no empty lines */
const config_1 = require("@v020/config");
Object.defineProperty(exports, "testableExternalConfig", { enumerable: true, get: function () { return config_1.config; } });
const config_2 = require("@root/config");
const config_3 = require("@root/config");
const deployedServiceAttributes_GENERATED_json_1 = tslib_1.__importDefault(require("./deployedServiceAttributes-GENERATED.json"));
const overrideObjectAttributes_1 = require("./overrideObjectAttributes");
const resolvedEnvironmentVariables_1 = require("./resolvedEnvironmentVariables");
const defaultEnvironmentSettings_1 = require("./default/defaultEnvironmentSettings");
const versions_1 = require("./versions");
const { NODE_ENV, REACT_APP_PROJECT_CODE, REACT_APP_DEPLOYMENT_STAGE, ECS_TASK_ARN, AWS_SESSION_TOKEN } = process.env;
const debug = process.env.REACT_APP_DEBUG === 'true' || (!(REACT_APP_PROJECT_CODE || ECS_TASK_ARN || AWS_SESSION_TOKEN) && false);
const isReact = (NODE_ENV === 'development' || NODE_ENV === 'production' || NODE_ENV === 'test') && !!REACT_APP_PROJECT_CODE && !!REACT_APP_DEPLOYMENT_STAGE;
let isDevLocalhost = false;
if (!process.env.AWS_LAMBDA_FUNCTION_NAME && isReact) {
    try {
        if (isReact && window?.location?.hostname === 'localhost') {
            isDevLocalhost = true;
        }
    }
    catch (e) {
        console.error('SUPPRESSED ERR setting isDevLocalhost, (eg where config is being tested locally in terminal). ', e.message);
    }
}
const deployedServiceAttributes = deployedServiceAttributes_GENERATED_json_1.default;
/** changed 2024 01 not to use destructuring for REACT_APP vars as React Native does not allow access except directly via process.env */
const { default_region, region, accountId, projectCode, appName, stage } = resolvedEnvironmentVariables_1.resolvedEnvironmentVariables;
const shortProjectCode = (projectCode ?? REACT_APP_PROJECT_CODE)?.substring(0, 4);
const internalAccountDomain = `${stage ?? REACT_APP_DEPLOYMENT_STAGE}.${shortProjectCode}.${config_2.parentHostedZoneName}`;
/** RSE (2025 09 26 )
 * this had been refactored to override baseConfig, which has no aws setting, so would have never been invoke
 * It is possible that any environment deployed with the previous setting will have not got venture specific settings applied to stacks
 */
if (default_1.config.aws && config_1.config.aws) {
    debug && console.log('Overriding aws ComputeDeploymentConfig with', JSON.stringify(config_1.config.aws.ComputeDeploymentConfig, null, 1));
    debug && console.log('Overriding aws environments with', JSON.stringify(config_1.config.aws.environments, null, 1));
    (0, overrideObjectAttributes_1.overrideObjectAttributes)({ overridableObject: default_1.config.aws, overridingObject: config_1.config.aws });
}
const { domain, weather, google, apps, BaseData: externalBaseData = {}, apiConfigs, iotv, mailFromAccountName, mailFromSubDomain, uiUrls, ventureTypeExtensions, externalDomain, notificationObjectHistory, incidentProducingTypes, } = config_1.config;
/** Add base `BaseData` (if not present) */
for (const [baseDataKey, baseDataDatum] of Object.entries(base_1.config.BaseData ?? {})) {
    if (!externalBaseData[baseDataKey]) {
        externalBaseData[baseDataKey] = {};
    }
    for (const dataDataDatum of Object.entries(baseDataDatum)) {
        const datumKey = dataDataDatum[0];
        const datumItems = dataDataDatum[1];
        const presentItems = externalBaseData[baseDataKey][datumKey] ?? [];
        // @ts-ignore — ADH (2025 07) I know this is correct, but I dont know how to type it
        externalBaseData[baseDataKey][datumKey] = [...presentItems, ...datumItems];
    }
}
const stageAtts = () => {
    let accountStageDeployedServiceAttributes = undefined;
    try {
        accountStageDeployedServiceAttributes = deployedServiceAttributes[accountId][stage];
    }
    catch (e) {
        let errMsg = undefined;
        if (!deployedServiceAttributes[accountId]) {
            errMsg = `No entry for account ${accountId}: ${Object.keys(deployedServiceAttributes)}`;
        }
        else if (!deployedServiceAttributes[accountId][stage]) {
            errMsg = `No stage ${stage} for account ${accountId}: ${Object.keys(deployedServiceAttributes[accountId])}`;
        }
        else {
            errMsg = e.message ?? `Unknown error for ${accountId} ${stage}`;
        }
        console.error(errMsg);
        throw new Error(errMsg);
    }
    return accountStageDeployedServiceAttributes;
};
const variableStageAtts = stageAtts();
const lwsApiEndpoints = [
    {
        name: 'NetworkApi',
        endpoint: `https://network.${internalAccountDomain}`,
        region: default_region,
    },
    {
        name: 'DeviceControlApi',
        endpoint: `https://devicecontrol.${internalAccountDomain}`,
        region: default_region,
    },
    {
        name: 'SystemManagementApi',
        endpoint: `https://system-management.${internalAccountDomain}`,
        region: default_region,
    },
    {
        name: 'ConsumerApi',
        endpoint: `https://consumer.${internalAccountDomain}`,
        region: default_region,
    },
];
const largeObjectIdentifier = 'Big:';
/** merged config */
const config = {
    version: versions_1.KinesisVideo,
    // TODO get into state from https://ipapi.co/json
    // this is semi complete 2025 01, probably reference to config.locale in UI should useIpConfig. Not investigated AWS side usages /
    locale: 'en-NZ',
    frameworkLicencee: config_3.frameworkLicencee,
    project: { code: projectCode },
    stage,
    app: {
        appName,
        appCode: projectCode,
        webUI: {
            ventureName: config_1.config.apps?.webUI?.ventureName ?? base_1.config.apps?.webUI?.ventureName ?? default_1.config.apps?.webUI?.ventureName,
            useSpecializedViews: config_1.config.apps?.webUI?.useSpecializedViews ?? base_1.config.apps?.webUI?.useSpecializedViews ?? default_1.config.apps?.webUI?.useSpecializedViews,
            initialRedirect: config_1.config.apps?.webUI?.initialRedirect ?? base_1.config.apps?.webUI?.initialRedirect ?? default_1.config.apps?.webUI?.initialRedirect,
            groupedObjectTypes: {
                ...base_1.config.apps?.webUI?.groupedObjectTypes,
                ...(config_1.config.apps?.webUI?.groupedObjectTypes ?? default_1.config.apps?.webUI?.groupedObjectTypes),
            },
            deviceMap: {
                ...base_1.config.apps?.webUI?.deviceMap,
                ...(config_1.config.apps?.webUI?.deviceMap ?? default_1.config.apps?.webUI?.deviceMap),
            },
            domainMap: { ...base_1.config.apps?.webUI?.domainMap, ...(config_1.config.apps?.webUI?.domainMap ?? default_1.config.apps?.webUI?.domainMap) },
            pruneGenericEntities: config_1.config.apps?.webUI?.pruneGenericEntities ?? base_1.config.apps?.webUI?.pruneGenericEntities ?? default_1.config.apps?.webUI?.pruneGenericEntities,
            pruneEntityNetworks: config_1.config.apps?.webUI?.pruneEntityNetworks ?? base_1.config.apps?.webUI?.pruneEntityNetworks ?? default_1.config.apps?.webUI?.pruneEntityNetworks,
            showProgrammeSets: config_1.config.apps?.webUI?.showProgrammeSets ?? base_1.config.apps?.webUI?.showProgrammeSets ?? default_1.config.apps?.webUI?.showProgrammeSets,
            showPrivacyPolicy: config_1.config.apps?.webUI?.showPrivacyPolicy ?? base_1.config.apps?.webUI?.showPrivacyPolicy ?? default_1.config.apps?.webUI?.showPrivacyPolicy,
            supportEmail: config_1.config.apps?.webUI?.supportEmail ?? base_1.config.apps?.webUI?.supportEmail ?? default_1.config.apps?.webUI?.supportEmail,
            defaultPreferences: {},
        },
        defaultTZ: 'NZ',
        supportedTZs: config_2.supportedTZs,
        namespace_uuid: 'a9f2227e-7d5d-4d8a-aecf-4a21cbf951cc',
        ghostUuid: 'xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx',
        regex: {
            globalAllow: '^[ A-Za-z0-9$�@:\!_\*,\)\(\-\.\?\+]*$',
            globalDisallow: 'pertempter',
            email: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$',
        },
        Alert: {
            latestSuffix: '_latestAlert',
            maxHistory: 30,
            noAlertMessage: 'All alerts resolved',
        },
        Shadow: {
            latestSuffix: '_latestShadowState',
        },
        LargeObjects: {
            pk_suffix: largeObjectIdentifier,
        },
        attributeLevelSeparator: ':',
        groups: {
            _Admin: '_Admin',
            _Users: '_Users',
        },
        datalifecycle: {
            ttlExpired: {
                days: 31,
            },
            calculatedState: {
                days: 100,
            },
        },
        geo: {
            S2: {
                defaultLevel: 20,
            },
            location: {
                DOP: {
                    minAccepatable: {
                        default: 10,
                    },
                },
            },
        },
    },
    aws: {
        parentAcccountId: config_2.parentAcccountId,
        parentAccountHostedZoneId: config_2.parentAccountHostedZoneId,
        parentHostedZoneName: config_2.parentHostedZoneName,
        default_region,
        name_separator: '-',
        accountId,
        nodeRuntime: 'nodejs20x',
        environments: default_1.config.aws?.environments ?? defaultEnvironmentSettings_1.defaultEnvironmentSettings,
        cdk: default_1.config.aws,
        apiConfigs: [...lwsApiEndpoints, ...(config_1.config.apiConfigs ?? [])],
        cognito: {
            REGION: default_region,
            ...variableStageAtts?.cognito,
            groupDefinitions: config_1.config.aws?.Cognito?.groupDefinitions,
        },
        dynamoDB: {
            ...variableStageAtts?.dynamoDB,
            tableName: `${projectCode}-${stage}-main-table`,
            apiVersion: '2012-08-10',
            pKey: 'pk',
            sKey: 'sk',
            dpKey: 'dpk',
            dsKey: 'dsk',
            priName: undefined,
            dynamicKeyGSIName: 'DYNAMIC',
            gsiName: 'GSI',
            tsiName: 'TSI',
            typesiName: 'TYPESI',
            typesiPrimaryKey: 'type',
            typesiSortKey: 'name',
            tsiSortKey: 'timestamp',
            ttl: {
                ThingShadowState: 7,
                DeviceControlTransaction: 7,
            },
            batchGetMax: 100,
            batchWriteMax: 25,
            queryLimit: 500,
        },
        identityCentre: {
            ...variableStageAtts?.identityCentre,
        },
        iot: {
            ...variableStageAtts?.iot,
        },
        mqtt: {
            userChannel: `${projectCode}/${stage}/user/[userId]`,
            networkChannel: `${projectCode}/${stage}/network/[app_id]`,
            awsDeviceUpdateTopic: '$aws/things/+/shadow/update',
            /** under deprecation due to spelling and pattern matching */
            appDeviceMessageConfirmedTopice: `${projectCode}/${stage}/things/thingId/confirmed`,
            /** per entity channel - used by EntityState when no customer is available. Replacement for appDeviceMessageConfirmedTopice */
            entityEntityStateUpdate: `${projectCode}/${stage}/things/+/confirmed`,
            customerEntityStateUpdate: `${projectCode}/${stage}/customer/[customerSk]/[entitySk]`,
            alertTopic: `${projectCode}/${stage}/things/thingId/alert`,
            /** channel for new and updated DCTs */
            deviceControlTransactionChannel: `${projectCode}/${stage}/deviceControl/transactions/[deviceSk]`,
            /** channel for Diagnostic message parts */
            deviceControlResponseChannel: `${projectCode}/${stage}/deviceControl/responses/[deviceSk]`,
            /** channel for updated DeviceConfigs */
            deviceConfigUpdateChannel: `${projectCode}/${stage}/deviceControl/deviceConfig/[deviceSk]`,
            /** IO status, UI clients publish to request the current status */
            ioStatusTopic: `${projectCode}/${stage}/io/status`,
            /** IO queue status, UI clients subscribe to see the current status */
            ioQueueTopic: `${projectCode}/${stage}/io/queue`,
            /** IO job status, UI clients subscribe to see the current status */
            ioJobTopic: `${projectCode}/${stage}/io/job/[userSk]`,
            topic: {
                shadowAccepted: 'shadowAccepted',
                alertIssued: 'alertIssued',
                userChannel: 'userChannel',
                networkChannel: 'network',
                customerChannel: 'customer',
            },
            topicRegex: {
                shadowAccepted: `${projectCode}/${stage}/things/.*?/confirmed`,
                alertIssued: `${projectCode}/${stage}/things/.*?/alert`,
                userChannel: `${projectCode}/${stage}/user/.*?`,
                networkChannel: `${projectCode}/${stage}/network/.*?`,
                deviceControl: `${projectCode}/${stage}/deviceControl/.*?`,
                customerChannel: `${projectCode}/${stage}/customer/.*?`,
            },
        },
        s3: {
            userBlobs: { Name: `${projectCode}-${stage}-userblobs` },
            emu: { Name: `${projectCode}-${stage}-ui-emu` },
            ui: { Name: `${projectCode}-${stage}-ui-version-2` },
            largeObjects: { Name: `${projectCode}-${stage}-datalifecycle-large-objects` },
            networkData: { Name: `${projectCode}-${stage}-datalifecycle-network-data` },
            networkCoverage: { Name: `${projectCode}-${stage}-network-coverage` },
            io: { Name: `${projectCode}-${stage}-io-jobs` },
        },
        sqs: {
            maxDelay: 180,
            subscriptionEvaluationQueue: {
                queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-subscriber-notification-queue`,
                queueUrl: `https://sqs.${region}.amazonaws.com/${accountId}/${projectCode}-${stage}-subscriber-notification-queue`,
            },
            notificationEmitterQueue: {
                queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-notification-emit-queue`,
                queueUrl: `https://sqs.${region}.amazonaws.com/${accountId}/${projectCode}-${stage}-notification-emit-queue`,
            },
            networkDataQueue: {
                queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-networkDataIngestion`,
                queueUrl: `https://sqs.${region}.amazonaws.com/${accountId}/${projectCode}-${stage}-networkDataIngestion`,
            },
        },
    },
    domain,
    internalAccountDomain,
    externalDomain,
    weather,
    google,
    apps,
    uiUrls: [`https://*.${internalAccountDomain}`, ...(uiUrls ?? [])],
    BaseData: externalBaseData,
    apiConfigs,
    iotv,
    mailFromSubDomain,
    ventureTypeExtensions,
    entityReadingsStrategy: config_1.config.entityReadings ?? default_1.config.entityReadings ?? 'S3_ATHENA_GLUE',
    notificationObjectHistory,
    incidentProducingTypes: [...(incidentProducingTypes ?? default_1.config.incidentProducingTypes ?? []), ...(base_1.config.incidentProducingTypes ?? [])],
    mailFromAccountName,
    /* TODO - required by SES under an assertion - currently SES has an Omit to avoid this */
    // parentAccountDomain: parentHostedZoneName,
};
if (isDevLocalhost) {
    config.google.gcp = default_1.config.google.gcp;
}
exports.default = config;
